<template>
  <v-dialog persistent v-model="reciprocityDurationModal" width="700">
    <v-card>
      <v-card-title class="headline blue darken-3 white--text" default-title>Reciprocity Visa Duration</v-card-title>
      <v-card-text class="pa-0">
        <v-container grid-list-md>
          <v-layout wrap>
            <form-error-display-handler :errors="errors"/>
            <v-flex xs12>
              <v-form ref="reciprocityDurationForm" v-model="valid" lazy-validation class="px-2">
                <v-alert type="info" outlined>
                  Visa Duration for {{ total_days }} days. Visa will be valid from
                  {{ start_date }} to {{ end_date }}
                </v-alert>

                <v-alert type="info" outlined>
                  Please provide stay duration for the reciprocity visa.
                </v-alert>

                <v-text-field
                    class="pl-1 pr-1"
                    outlined
                    label="Total days *"
                    @focus="focusOnDays"
                    @blur="focusOnDaysData = false"
                    v-model="total_days"
                    :rules="[rules.required]"
                ></v-text-field>

                <v-text-field v-if="$store.state.VisaRequestSingle.extended_reciprocity_visa"
                              class="pl-1 pr-1"
                              outlined
                              label="Visa Fee (USD) *"
                              v-model="visa_fee"
                              :rules="[rules.required]"
                ></v-text-field>

                <new-date-picker
                    class="pl-1 pr-1 mb-4"
                    label="Visa Start Date *"
                    v-model="start_date"
                    readonly=""
                />

                <new-date-picker
                    class="pl-1 pr-1 mb-4"
                    label="Visa End Date *"
                    :watch-value="true"
                    v-model="end_date"
                />
                <v-radio-group class="pl-1 pr-1 mb-4" v-model="type" :mandatory="true" row :rules="[rules.required]">
                  <v-radio
                      label="Per Visit"
                      value="per_visit"
                  ></v-radio>
                  <v-radio
                      label="Per Year"
                      value="per_year"
                  ></v-radio>
                </v-radio-group>
              </v-form>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-divider/>
      <v-card-actions>
        <v-spacer/>
        <v-btn
            color="red lighten-1"
            class="white--text"
            @click="closeModal"
        >Close
        </v-btn>
        <v-btn color="blue darken-3" :loading="loading" class="white--text" @click="submit">Submit</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import moment from "moment";
import FormErrorDisplayHandler from "../FormErrorDisplayHandler";
import {validationMixin} from "../../mixins/validationMixin";
import NewDatePicker from "../NewDatePicker";

export default {
  data: () => ({
    valid: true,
    reciprocityDurationForm: {},
    errors: [],
    loading: false,
    start_date: null,
    end_date: null,
    total_days: 0,
    visa_fee: null,
    focusOnDaysData: false,
    type: null,
  }),
  components: {
    NewDatePicker,
    FormErrorDisplayHandler,

  },
  mounted() {
    this.start_date = this.visaStartDate
  },
  props: ['status', 'visaStartDate', 'visaEndDate'],
  mixins: [validationMixin],
  watch: {
    value(input) {
      this.innerOpen = input;
    },
    innerOpen(value) {
    },
    start_date() {
      this.start_date = this.visaStartDate
    },
    end_date() {
      if (!this.focusOnDaysData) {
        this.calculateTotalDays()
      }
    },
    total_days() {
      if (this.focusOnDaysData) {
        this.end_date = moment(this.start_date).add((this.total_days - 1), 'days').format('YYYY-MM-DD')
      }
    }
  },
  computed: {
    ...mapGetters("VisaRequestSingle", ["visaRequest"]),
    reciprocityDurationModal: {
      get() {
        return this.$store.state.VisaRequestSingle.reciprocityDurationModal;
      },
      set(value) {
        this.$store.commit("VisaRequestSingle/setReciprocityDurationModal", value);
      }
    },
  },
  methods: {
    ...mapActions("VisaRequestSingle", ["reciprocityDurationRequest"]),
    focusOnDays() {
      this.focusOnDaysData = true;
    },
    calculateTotalDays() {
      const start_date = moment(this.start_date);
      const end_date = moment(this.end_date);
      const date_diff = end_date.diff(start_date, 'days');
      this.total_days = (date_diff + 1);
    },
    submit() {
      if (this.$refs.reciprocityDurationForm.validate()) {
        let formData = new FormData();
        formData.set('start_date', this.start_date)
        formData.set('end_date', this.end_date)
        formData.set('duration', this.total_days)
        formData.set('type', this.type)
        formData.set('visa_fee', this.visa_fee)

        this.loading = true;
        this.reciprocityDurationRequest(formData)
            .then(() => {
              this.form = false;
              this.reciprocityDurationForm = [];
              this.errors = null;
              this.reciprocityDurationModal = false;
              this.loading = false;
              this.$store.commit("Notification/showSuccess", "Reciprocity visa duration added successfully");
              this.$store.commit("VisaRequestSingle/setReciprocityDurationModal", true);
              this.$refs.reciprocityDurationForm.reset();
            })
            .catch(error => {
              this.loading = false;
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
              }
              this.$store.commit('Notification/showError', error.response.data.message)
            });
      } else {
        this.$store.commit("Notification/showError", "Invalid Form Data");
      }
    },
    closeModal() {
      this.reciprocityDurationForm = {};

      this.reciprocityDurationModal = false;

    },
  }
  ,
}
;
</script>

<style scoped>

</style>
